import { GroupForm } from '../../components-domain/education-domain/courses/GroupForm';
import { layoutWorkspace } from '../../_website/_common/layout.workspace';
import {
  ConfigSection,
  CreateTemplate,
  EditTemplate,
} from '../../components-fabric';
import { PageTable } from '@components-common/layouts';
import { getGroupValidationSchema } from '../../components-domain/education-domain/courses/group.schema';
import { PageFormToolbar } from '../../components-common/layout/views/PageFormToolbar';
import { clone } from 'ramda';
import { LecturersColumn, StudentsCountColumn } from './_customCollumns';

const formScreen = {
  Component: PageFormToolbar,
  form: GroupForm,
  template: `coursesms/groups`,
  schema: getGroupValidationSchema(),
  empty: {
    name: '',
    description: '',
  },
};

export const courseGroupsScreens: ConfigSection = {
  id: 'groups',
  path: 'groups',
  title: 'Groups',
  layout: layoutWorkspace,
  screens: [
    {
      id: 'index',
      path: '.',
      roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
      left: [
        {
          id: 'create_new',
          kind: 'create_new',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
        } as any,
      ],
      Component: PageTable,
      source: '/coursesms/groups',
      urlParams: {
        courseId: '{id}',
      },
      tmp: 'index',
      columns: ['name', 'description', StudentsCountColumn, LecturersColumn],
      empty: {
        name: '',
        description: '',
      },
      actions: [
        {
          id: 'edit',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
          actionToDispatch: { payload: { path: '' } },
          displayTooltip: true,
          tooltipText: 'Edit group',
        } as any,
        {
          id: 'delete',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
          actionToDispatch: {
            payload: {
              endpointToDelete: '/coursesms/groups',
            },
          },
          displayTooltip: true,
          tooltipText: 'Delete group',
        },
      ],
    } as any,
    {
      id: 'create',
      path: 'new',
      tmp: 'create',
      roles: ['STUDY_DIRECTOR', 'LECTURER'],
      left: ['create'],
      ...clone(formScreen),
    } as CreateTemplate,
    {
      ...clone(formScreen),
      left: ['save'],
      right: ['back'],
      id: 'edit',
      path: ':groupId',
      editSource: `coursesms/groups/`,
      roles: ['STUDY_DIRECTOR', 'LECTURER'],
      idPropSource: 'groupId',
      tmp: 'edit',
    } as EditTemplate,
  ],
};
